import { useState } from "react";
import { Check, Copy, Wallet } from "lucide-react";
import { shortWallet, useApi } from "../../dashboard/api";
import { Skeleton } from "./ui";

export const WalletPill = ({ compact = false }) => {
    const { data, loading } = useApi("summary");
    const [copied, setCopied] = useState(false);

    const copy = async () => {
        if (!data) return;
        try {
            await navigator.clipboard.writeText(data.user.wallet);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {}
    };

    if (loading || !data) {
        return <Skeleton className="h-9 w-32 rounded-full" />;
    }

    return (
        <button
            type="button"
            onClick={copy}
            data-testid="wallet-pill"
            title="Copy wallet address"
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-nx-elev px-3.5 py-2 text-xs font-semibold text-nx-text transition-colors duration-200 hover:border-white/20"
        >
            <Wallet size={13} strokeWidth={1.5} className="text-nx-lime" aria-hidden="true" />
            <span className="font-mono">{shortWallet(data.user.wallet)}</span>
            {copied ? (
                <Check size={12} strokeWidth={2} className="text-nx-lime" aria-hidden="true" />
            ) : (
                <Copy size={12} strokeWidth={1.5} className="text-nx-mute" aria-hidden="true" />
            )}
            <span className="sr-only">{copied ? "Copied" : "Copy address"}</span>
        </button>
    );
};
